const {Component} = require("react");
const PropTypes = require("prop-types");
const Image = require("app/components/mixins/LazyImg");
const { numberFormat } = require('app/util/formaters')
const Trans = require('app/components/trans/Trans')

class Product extends Component {

	static get propTypes() {
		return {
			name: PropTypes.string.isRequired,
			price: PropTypes.object.isRequired,
			priceFrom: PropTypes.number.isRequired,
			picture: PropTypes.object.isRequired,
			url: PropTypes.string,
			excerpt: PropTypes.string
		};
	}

	static get defaultProps() {
		return {
			url: "#",
			excerpt: ""
		};
	}

	get variationsHtml() {
		if (this.props.price.values.length > 1) {
			return (<span>{this.props.price.values.length} <Trans>varianter</Trans></span>);
		}
	}

	get price() {
		return numberFormat(this.props.priceFrom);
	}

	get priceHtml() {
		let priceFrom = null;

		if ((this.props.price.values.length > 1) || (this.props.price.custom)) {
			priceFrom = (<span className="from"><Trans>Fra</Trans></span>);
		}

		return (
			<div className="price">
				{priceFrom}
				{this.price}
			</div>
		);
	}

	render() {
		return (
			<div className="search-item product">
				<div className="thumbnail object-fit">
					<a href={this.props.url}>
						<Image src={this.props.picture.b} name={this.props.name} loader={false} afterload={'true'}/>
					</a>
				</div>
				<div className="info">
					<div className="title">
						<a href={this.props.url}>
							{this.props.name}
						</a>
					</div>
					<div className="subtitle">
						<span><Trans>Produkt</Trans></span>
						{this.variationsHtml}
					</div>
					{this.priceHtml}
					<div className="description">{this.props.excerpt}</div>
					<a className="arrow-link" href={this.props.url}></a>
				</div>
			</div>
		);
	}

}

module.exports = Product;
